/**
 * RabbitMQTestService
 * Service for testing RabbitMQ messaging
 * Route: api/rabbitmqtest
 */
import { BaseService } from '../base/BaseService';
export class RabbitMQTestService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RabbitMQTestService.DEFAULT_SERVICE_PATH,
            basePath: RabbitMQTestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async sendMessage(request) {
        const endpoint = this.getEndpoint('send', 'send');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async sendMultipleMessages(request) {
        const endpoint = this.getEndpoint('send-multiple', 'send-multiple');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async sendCacheInvalidationEvent(request) {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache-invalidate');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async sendNotificationEvent(request) {
        const endpoint = this.getEndpoint('notification', 'notification');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async sendWorkflowEvent(request) {
        const endpoint = this.getEndpoint('workflow', 'workflow');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async testPublisherConfirms(request) {
        const endpoint = this.getEndpoint('test-publisher-confirms', 'test-publisher-confirms');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async getConfig() {
        const endpoint = this.getEndpoint('config', 'config');
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
}
RabbitMQTestService.DEFAULT_SERVICE_PATH = 'system';
RabbitMQTestService.BASE_PATH = 'api/rabbitmqtest';
//# sourceMappingURL=RabbitMQTestService.js.map